import { useEffect, useState } from 'react'

// Lets a page/tab hide the floating AI assistant circle while it is mounted,
// without touching the assistant's own mount points. The Calcutta tab uses this
// because its auction AI is built into the tab (toggles + speak/type), so the
// global circle is redundant and confusing there. A ref count supports nesting
// and keeps the circle visible everywhere else the moment the hider unmounts.
let hideCount = 0
const listeners = new Set()
function emit() {
  const hidden = hideCount > 0
  listeners.forEach((l) => l(hidden))
}

// Call inside a component that should hide the assistant while it is on screen.
export function useHideAiAssistant() {
  useEffect(() => {
    hideCount += 1
    emit()
    return () => {
      hideCount -= 1
      emit()
    }
  }, [])
}

// Read whether any mounted hider currently wants the assistant hidden.
export function useAiAssistantHidden() {
  const [hidden, setHidden] = useState(() => hideCount > 0)
  useEffect(() => {
    const l = (h) => setHidden(h)
    listeners.add(l)
    setHidden(hideCount > 0)
    return () => { listeners.delete(l) }
  }, [])
  return hidden
}
